(function(root,factory){
  'use strict';
  if(typeof module==='object'&&module.exports)module.exports=factory(require('./nikuya-cart-runtime-authority.js'),require('./nikuya-cart-managed-ownership.js'));
  else root.NikuyaCartNoGifts=factory(root.NikuyaCartRuntimeAuthority,root.NikuyaCartManagedOwnership);
})(globalThis,function(Authority,Ownership){
  'use strict';
  const policy='KNIFE_ONLY_20260924';
  const canonical=value=>JSON.stringify(value,(_,v)=>v&&typeof v==='object'&&!Array.isArray(v)?Object.fromEntries(Object.keys(v).sort().map(k=>[k,v[k]])):v);
  const marked=line=>line.managedLooking===true||Object.keys(line.properties||{}).some(k=>k.startsWith('_nikuya_'));
  // Shopify may rotate an anonymous token until the first item materializes.
  // Two authoritative empty reads have no merchandise ownership to bind.
  const empty=s=>s?.authoritative===true&&s.itemCount===0&&Array.isArray(s.items)&&s.items.length===0;
  const sameCart=(a,b)=>a.binding===b.binding||(empty(a)&&empty(b));
  const shape=s=>canonical({binding:empty(s)?null:s.binding,note:s.note,attributes:s.attributes,items:s.items.map(l=>({key:l.key,sku:l.sku,product_id:l.product_id,variant_id:l.variant_id,quantity:l.quantity,properties:l.properties,final_price:l.final_price,final_line_price:l.final_line_price,selling_plan_allocation:l.selling_plan_allocation})).sort((a,b)=>a.key.localeCompare(b.key)),discount_codes:s.discount_codes});
  const selected=s=>s.items.filter(marked);
  const acquisitionCode=code=>['NKYACQ10','NKYACQ15'].includes(String(code).toUpperCase());
  const wrongAcquisition=(s,c)=>s.discount_codes?.some(d=>d.applicable&&acquisitionCode(d.code)&&String(d.code).toUpperCase()!==c.expectedProfile)===true;
  const customerCode=s=>s.discount_codes?.some(d=>d.applicable&&!acquisitionCode(d.code))===true;
  function covered(snapshot,context){
    const heroes=snapshot.items.filter(l=>Authority.mappingFor(l).kind==='hero');
    if(!heroes.length||wrongAcquisition(snapshot,context))return false;
    if(snapshot.discount_codes?.some(d=>d.applicable&&String(d.code).toUpperCase()===context.expectedProfile))return true;
    const percent=context.stage==='C4'?15:10;
    return heroes.every(l=>Number.isSafeInteger(l.original_price)&&l.original_price>0&&Number.isSafeInteger(l.final_price)&&l.final_price>=0&&l.final_price<=Math.ceil(l.original_price*(100-percent)/100)&&l.line_level_discount_allocations?.some(a=>Number.isSafeInteger(a.amount)&&a.amount>0));
  }
  function cleanupPlan(snapshot,evidence,now=Date.now()){
    const keys=[];
    if(!snapshot?.authoritative||!evidence?.meta||evidence.pending)return {keys,review:selected(snapshot)};
    const {meta,marker,receipts}=evidence;
    if(meta.binding!==snapshot.binding||meta.id!==marker||meta.mappingRevision!==Authority.mappingRevision||meta.v!==1||!Number.isSafeInteger(meta.createdAt)||!Number.isSafeInteger(meta.expiresAt)||meta.createdAt<0||meta.createdAt>now||meta.expiresAt<=meta.createdAt||meta.expiresAt>meta.createdAt+604800000)return {keys,review:selected(snapshot)};
    for(const mapping of Authority.mappings){
      const receipt=receipts?.[mapping.caseSku];
      if(!receipt||receipt.quantity<=0||receipt.createdAt<meta.createdAt||receipt.updatedAt>now||receipt.expiresAt>meta.expiresAt)continue;
      try{
        const ledger=Ownership.create({binding:snapshot.binding,sessionId:marker,mapping,revision:{mapping:meta.mappingRevision,acquisition:meta.acquisitionRevision},ttlMs:604800000,authorityExpiresAt:meta.expiresAt,clock:()=>Math.min(now,receipt.expiresAt-1),newId:()=>{throw Error('CLEANUP_ONLY')}});
        const result=ledger.verifyFamily(receipt,snapshot);
        if(result.status==='VERIFIED')keys.push(...result.keys);
      }catch(_){}
    }
    return {keys,review:selected(snapshot).filter(l=>!keys.includes(l.key))};
  }
  function create({read,write,context,store,canPersist=()=>false,locks,origin,onChange=()=>{}}={}){
    const journalKey='nikuya:no-gifts:v1:'+origin;
    let pending=null,busy=false,queue=Promise.resolve(),reviewed=null,last=null,reviewScope=null;
    async function reviewRecord(){
      try{if(canPersist())reviewScope=await store.get(journalKey+':review')}catch(_){}
      reviewed=reviewScope?.shape||null;
      return reviewScope;
    }
    async function evidence(s){
      if(!canPersist())return null;
      const key='nikuya:managed:v1:'+s.binding;
      try{return {meta:await store.get(key+':session-meta'),marker:await store.get(key+':session'),pending:await store.get(key+':pending'),receipts:Object.fromEntries(await Promise.all(Authority.mappings.map(async m=>[m.caseSku,await store.get(key+':'+m.caseSku)])))};}catch(_){return null}
    }
    async function journal(value,required=false){pending=value;if(canPersist()){try{await store.set(journalKey,value)}catch(error){if(required)throw error}}}
    async function getPending(){if(pending)return pending;try{return canPersist()?await store.get(journalKey):null}catch(_){return null}}
    async function legacyPending(){if(!canPersist())return null;try{return await store.get('nikuya:managed:v1:native-unbound')||await store.get('nikuya:managed:v1:scope:'+origin+':bootstrap-pending')}catch(_){return null}}
    async function exclusive(task){
      const job=queue.then(async()=>{
        const run=async()=>{
          const hint=await read();
          const bound=async()=>{const fresh=await read();if(!sameCart(fresh,hint))throw Error('CART_CHANGED');return task(fresh)};
          return locks?.request?locks.request('nikuya:managed:v1:'+hint.binding,{mode:'exclusive'},bound):bound();
        };
        busy=true;
        try{return await (locks?.request?locks.request('nikuya:managed:v1:scope:'+origin,{mode:'exclusive'},run):run())}
        finally{busy=false;try{onChange()}catch(_){/* Observers cannot invalidate an acknowledged native response. */}}
      });
      queue=job.catch(()=>{});return job;
    }
    async function discount(snapshot){
      const acquisition=await context.read();
      if(acquisition.status!=='VERIFIED_CONTEXT'||!snapshot.items.some(l=>Authority.mappingFor(l).kind==='hero'))return {status:'ORDINARY'};
      if(covered(snapshot,acquisition))return {status:'APPLIED_OR_BETTER_OFFER'};
      if(customerCode(snapshot)&&!wrongAcquisition(snapshot,acquisition))return {status:'CUSTOMER_CODE_PRESERVED'};
      const codes=(snapshot.discount_codes||[]).filter(d=>!acquisitionCode(d.code)).map(d=>d.code);
      const response=await write({endpoint:'cart/update.js',body:{discount:[...codes,acquisition.expectedProfile].join(',')}});
      const after=await read();
      if(!response.ok||after.binding!==snapshot.binding)return {status:'DISCOUNT_REVIEW'};
      return {status:covered(after,acquisition)?'APPLIED':'DISCOUNT_REVIEW'};
    }
    async function cleanup(snapshot){
      if(await legacyPending())return snapshot;
      if((await reviewRecord())?.binding===snapshot.binding)return snapshot;
      const saved=await evidence(snapshot),plan=cleanupPlan(snapshot,saved);
      if(!plan.keys.length||!canPersist()||!locks?.request)return snapshot;
      const keep=s=>canonical({binding:s.binding,note:s.note,attributes:s.attributes,codes:s.discount_codes,items:s.items.filter(l=>!plan.keys.includes(l.key)).map(l=>[l.sku,l.product_id,l.variant_id,l.quantity,l.properties,l.selling_plan_allocation]).sort((a,b)=>canonical(a).localeCompare(canonical(b)))});
      await journal({kind:'CLEANUP',binding:snapshot.binding,keys:plan.keys,before:shape(snapshot)},true);
      const response=await write({endpoint:'cart/update.js',body:{updates:Object.fromEntries(plan.keys.map(k=>[k,0]))}});
      const after=await read(),again=await read();
      if(!response.ok||after.revision===again.revision||shape(after)!==shape(again)||keep(snapshot)!==keep(again)||again.items.some(l=>plan.keys.includes(l.key)))throw Error('CLEANUP_REVIEW');
      // Keep ownership records until an acknowledged removal and two fresh reads.
      const key='nikuya:managed:v1:'+snapshot.binding;
      for(const mapping of Authority.mappings){
        if(plan.keys.some(k=>snapshot.items.find(l=>l.key===k)?.sku===mapping.caseSku))await store.set(key+':'+mapping.caseSku,null);
      }
      await journal(null);
      return again;
    }
    async function request(kind,send){
      return exclusive(async snapshot=>{
        if(await getPending()){last={status:'CART_REVIEW_REQUIRED'};throw Error('CART_REVIEW_REQUIRED')}
        await reviewRecord();reviewed=null;
        if(reviewScope){reviewScope={...reviewScope,shape:null};if(canPersist()){try{await store.set(journalKey+':review',reviewScope)}catch(_){}}}
        await journal({kind,binding:snapshot.binding,before:shape(snapshot)});
        let response;
        try{
          response=await send();
          const after=await read(),again=await read();
          if(shape(after)!==shape(again)||after.revision===again.revision)throw Error('CART_REVIEW_REQUIRED');
          // Rejected native requests are not replayed. The UI receives the original error.
          if(!response.ok){
            if(shape(snapshot)===shape(again))await journal(null);
            return response;
          }
          await journal(null);
          const clean=await cleanup(again);
          try{last=await discount(clean)}catch(_){last={status:'DISCOUNT_REVIEW'}}
          return response;
        }catch(error){
          last={status:'CART_REVIEW_REQUIRED',nativeAcknowledged:response?.ok===true};
          // Shopify's acknowledged response must reach the native success handler.
          // Retain the journal and checkout hold; never replay the add.
          if(response?.ok===true)return response;
          throw error;
        }
      });
    }
    async function reconcile(){
      return exclusive(async snapshot=>{
        if(await getPending())return {status:'CART_REVIEW_REQUIRED'};
        const clean=await cleanup(snapshot);
        try{last=await discount(clean)}catch(_){last={status:'DISCOUNT_REVIEW'}}
        return {status:'SETTLED'};
      });
    }
    async function recover(){
      return exclusive(async snapshot=>{
        const again=await read();
        if(snapshot.revision===again.revision||shape(snapshot)!==shape(again))throw Error('CART_CHANGED');
        const previous=await getPending();
        // Preserve uncertainty as evidence, disarm automatic gift cleanup, and allow
        // deliberate edits. This action does not approve checkout or replay a write.
        const record={binding:again.binding,shape:null,editing:true,priorPending:previous||reviewScope?.priorPending||null};
        if(canPersist()){
          await store.set(journalKey+':review',record);
          if(canonical(await store.get(journalKey+':review'))!==canonical(record))throw Error('RECOVERY_NOT_DURABLE');
        }
        reviewScope=record;reviewed=null;
        await journal(null,true);last={status:'EDITING_FOR_REVIEW'};
        return again;
      });
    }
    async function keepCase(key,expectedShape){
      return exclusive(async snapshot=>{
        if(await getPending())throw Error('CART_REVIEW_REQUIRED');
        if(shape(snapshot)!==expectedShape)throw Error('CART_CHANGED');
        const line=snapshot.items.find(l=>l.key===key);
        if(!line||!marked(line)||Authority.mappingFor(line).kind!=='case')throw Error('CASE_IDENTITY_REQUIRED');
        if(line.properties?._case_purchase&&line.properties._case_purchase!=='customer-selected')throw Error('CASE_IDENTITY_REQUIRED');
        const properties={...Object.fromEntries(Object.entries(line.properties||{}).filter(([k])=>!k.startsWith('_nikuya_'))),_case_purchase:'customer-selected'};
        const merchandise=items=>{
          const quantities=new Map();
          for(const l of items){
            const id=canonical([l.sku,String(l.product_id),String(l.variant_id),l.properties,l.selling_plan_allocation?.selling_plan?.id||null]);
            quantities.set(id,(quantities.get(id)||0)+l.quantity);
          }
          return canonical([...quantities].sort(([a],[b])=>a.localeCompare(b)));
        };
        const expected=merchandise(snapshot.items.map(l=>l.key===key?{...l,properties}:l));
        reviewScope={...reviewScope,binding:snapshot.binding,shape:null,editing:true};reviewed=null;
        if(canPersist())await store.set(journalKey+':review',reviewScope);
        await journal({kind:'KEEP_CASE',binding:snapshot.binding,key,before:shape(snapshot)},true);
        const response=await write({endpoint:'cart/change.js',body:{id:key,quantity:line.quantity,properties}});
        const after=await read(),again=await read();
        if(!response.ok||after.revision===again.revision||shape(after)!==shape(again)||snapshot.binding!==again.binding||canonical(snapshot.note)!==canonical(again.note)||canonical(snapshot.attributes)!==canonical(again.attributes)||expected!==merchandise(again.items))throw Error('CART_REVIEW_REQUIRED');
        await journal(null);last={status:'PRICE_REVIEW_REQUIRED'};
        return again;
      });
    }
    async function review(expectedShape){
      return exclusive(async snapshot=>{
        const again=await read();
        if(snapshot.revision===again.revision||shape(snapshot)!==shape(again))throw Error('CART_CHANGED');
        if(expectedShape&&shape(again)!==expectedShape)throw Error('CART_CHANGED');
        if(selected(again).length)throw Error('CASE_CHOICE_REQUIRED');
        // Explicit customer acknowledgement never grants deletion authority or retries a write.
        reviewed=shape(again);reviewScope={...reviewScope,binding:again.binding,shape:reviewed,editing:false};
        if(canPersist()){try{await store.set(journalKey+':review',reviewScope)}catch(_){}}
        await journal(null);last={status:'REVIEWED'};
        return again;
      });
    }
    async function state(snapshot){
      await reviewRecord();
      const legacy=await evidence(snapshot);
      const oldPending=legacy?.pending||await legacyPending();
      const editing=reviewScope?.binding===snapshot.binding&&reviewScope.editing===true;
      const unresolved=busy||!!await getPending()||!!(oldPending&&!editing&&reviewed!==shape(snapshot));
      const acquisition=await context.read();
      const missingOffer=acquisition.status==='VERIFIED_CONTEXT'&&snapshot.items.some(l=>Authority.mappingFor(l).kind==='hero')&&(!customerCode(snapshot)||wrongAcquisition(snapshot,acquisition))&&!covered(snapshot,acquisition);
      const needsReview=selected(snapshot).length>0||(missingOffer||editing||snapshot.items.some(l=>l.properties?._case_purchase==='customer-selected'))&&reviewed!==shape(snapshot);
      return {policy,unresolved,needsReview,editing,discountReady:covered(snapshot,acquisition),reviewLines:selected(snapshot),discount:last};
    }
    return Object.freeze({request,reconcile,recover,keepCase,review,state,evidence,status:()=>last,policy});
  }
  return Object.freeze({policy,create,cleanupPlan,marked,shape,covered});
});
